import { Check } from 'lucide-react';
import Icon from './Icon';

export default function Checkbox({ label, className, ...rest }) {
  return (
    <label className={['ui ui-check', className].filter(Boolean).join(' ')}>
      <input type="checkbox" {...rest} />
      <span className="ui-check__box" aria-hidden="true"><Icon icon={Check} /></span>
      <span>{label}</span>
    </label>
  );
}
